import React from "react";

import "./loader.scss";

const Loader = ({
  full = false,
  center = false,
  fill = false,
  light,
  className = "",
}) => {
  return (
    <div className={`loading-container ${fill ? "fill" : ""} ${className} `}>
      <div
        className={`main-loader  ${full ? "full" : ""}  ${
          center ? "center" : ""
        }  ${light ? "light" : "default"}`}
      />
    </div>
  );
};

export default Loader;
